import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'pl', label: 'Polski' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const change = (code: string) => {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-foreground-900 cursor-pointer whitespace-nowrap"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-global-line text-base"></i>
        </span>
        <span className="uppercase">{i18n.language === 'pl' ? 'PL' : i18n.language === 'es' ? 'ES' : i18n.language === 'fr' ? 'FR' : 'EN'}</span>
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-down-s-line text-sm"></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-40 overflow-hidden rounded-lg border border-background-200 bg-white py-1">
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => change(lang.code)}
              className={`flex w-full items-center justify-between px-4 py-2 text-left text-sm transition-colors cursor-pointer whitespace-nowrap ${
                i18n.language === lang.code
                  ? 'bg-primary-100 text-primary-700 font-semibold'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {lang.label}
              {i18n.language === lang.code && (
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-check-line text-sm"></i>
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}